import Vue from "vue";
import Vuex from "vuex";
import _ from "lodash";

import { collateBot } from "./util";

import { Auth } from "aws-amplify";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    authState: "loading",
    user: {
      email: "",
      isDemo: false
    },
    pollState: true,
    botState: {},
    notification: {
      type: "error",
      timeout: 3000,
      message: ""
    },
    bots: []
  },
  mutations: {
    authState(state, payload) {
      state.authState = payload;
    },
    user(state, payload) {
      state.user = payload;
    },
    botState(state, { name, value }) {
      for (let r of Object.values(value.races.races)) {
        r.bot = name;
      }
      Vue.set(state.botState, name, value);
    },
    setNotification(state, { type, timeout, message }) {
      state.notification.message = message;
      state.notification.type = type;
      if (timeout) state.notification.timeout = timeout;
    },
    clearNotification(state) {
      state.notification.message = "";
    }
  },
  actions: {
    async checkLogin({ commit }) {
      console.log("checking login");

      try {
        const user = await Auth.currentAuthenticatedUser();
        commit("authState", "authenticated");
        commit("user", {
          email: user.attributes.email,
          isDemo: user.attributes["custom:demo"] === "1"
        });
      } catch (err) {
        commit("authState", "unauthenticated");
        commit("user", { email: "", isDemo: false });
      }
    },
    async logout({ commit }) {
      await Auth.signOut();
      commit("authState", "unauthenticated");
      commit("user", { email: "", isDemo: false });
    }
  },
  getters: {
    isLoggedIn: state => state.authState === "authenticated",
    loading: state => state.authState === "loading",

    onlineBookies: function(state) {
      const bookies = collateBot(state.botState, "activeBookies");
      for (let i = 0; i < bookies.length; i++) {
        if (bookies[i].bookie === "sportsbetting") {
          bookies[i] = {
            ...bookies[i],
            bookie: "boombet"
          };
        }
      }

      return bookies;
    },

    refreshingBookies: function(state) {
      return collateBot(state.botState, "refreshingBookies");
    },

    betAttempts: state => (bot, bookie) => {
      if (bookie === "boombet") bookie = "sportsbetting";

      const { max_attempts = 0, current = 0 } = _.get(
        state.botState,
        [bot, "bet_limits", bookie],
        {}
      );

      return { max_attempts, current };
    },

    monitoredRaces: function(state) {
      const races = collateBot(state.botState, "races.races").filter(
        r => r.monitoringState === "MONITORING_RACE"
      );

      for (const r of races) {
        if (r.bookie === "sportsbetting") {
          r.bookie = "boombet";
        }
      }

      return _.sortBy(races, ["startTime"]);
    },

    upcomingRaces: function(state) {
      const races = collateBot(state.botState, "races.races");
      for (const r of races) {
        if (r.bookie === "sportsbetting") {
          r.bookie = "boombet";
        }
      }

      return _.chain(races)
        .filter(
          r =>
            r.monitoringState === "SCHEDULED" || r.monitoringState === "QUEUED"
        )
        .sortBy(["startTime"])
        .value();
    },

    betfairStatus: state => bot => {
      const status = _.get(state.botState, [bot, "betfair", "status"]);

      return status;
    },

    selectionsByRaceID: state =>
      function(bot, raceID) {
        const selectionIDs = _.get(
          state.botState,
          `${bot}.races.selectionsByRaceID.${raceID}`,
          []
        );
        const selections = [];
        for (const id of selectionIDs) {
          if (state.botState[bot].races.selections[id]) {
            selections.push(state.botState[bot].races.selections[id]);
          }
        }
        return selections;
      },

    getBookiePrice: state =>
      function(bot, raceID, selectionNumber, marketType) {
        return _.get(state.botState, [
          bot,
          "prices",
          "bookies",
          raceID,
          marketType,
          selectionNumber
        ]);
      },

    getBookiePriceUpdates: state =>
      function(bot, bookie) {
        return _.get(state.botState, [
          bot,
          "prices",
          "bookiePriceUpdates",
          bookie
        ]);
      },

    getBookieMarket: state =>
      function(bot, raceID, marketType) {
        const prices = _.get(state.botState, [
          bot,
          "prices",
          "bookies",
          raceID,
          marketType
        ]);

        if (!prices) return 0;

        let total = 0;
        for (const p of Object.values(prices)) {
          if (p) {
            total += 1 / p;
          }
        }

        return total;
      },

    getBetfairVolume: state =>
      function(bot, marketID) {
        const prices = _.get(state.botState, [
          bot,
          "prices",
          "betfair",
          marketID
        ]);

        if (!prices) return 0;

        let totalVolume = 0;
        for (const p of Object.values(prices)) {
          if (p.vol) {
            totalVolume += p.vol;
          }
        }

        return totalVolume;
      },
    getBetfairPrices: state =>
      function(bot, marketID, selectionID, betfairType) {
        return _.get(state.botState, [
          bot,
          "prices",
          "betfair",
          marketID,
          selectionID,
          betfairType
        ]);
      }
  }
});
